module.exports = __webpack_public_path__ + "9cbf22e503469c7e17467b6107f0d05a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cylindre-demi.png
// module id = 814
// module chunks = 0